export const socialLinks = {
  facebook: "https://www.facebook.com/atdoorofficial",
  youtube: "https://www.youtube.com/channel/UC69JxB7yPBY7wmOxjPkoFsg",
  twitter: "https://twitter.com/atdoorofficial",
  linkedin: "https://www.linkedin.com/company/77739113/admin/",
  github: "https://github.com/atdoorofficial",
};

export const webLinks = {
  website: "https://atdoor.net",
  services: "https://utility.atdoor.net/services",
  about: "https://atdoor.net/aboutus",
  terms: "https://utility.atdoor.net/terms",
  privacyPolicy: "https://utility.atdoor.net/privacy",
};
